import {Star} from "lucide-react";

export const RatingStars = ({ rating }) => (
  <div className="flex items-center gap-1 mb-3">
    {Array.from({ length: rating }).map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-primary text-primary" />
    ))}
  </div>
);